import { cn } from '@reelplicate/ui';
import type { ElementType } from 'react';

const TONES = {
  brand: 'bg-brand-primary text-icon-primary',
  success: 'bg-status-success-solid text-icon-inverse',
  warning: 'bg-status-warning-solid text-icon-primary',
  danger: 'bg-status-danger-solid text-icon-inverse',
} as const;

export type StatusIconProps = {
  icon: ElementType<{ className?: string }>;
  tone?: keyof typeof TONES;
};

/**
 * Figma "Auth / Status icon" (108:1268): the solid 56px tone tile heading a
 * status screen, radius/xl, Shadow/SM, with a 28px icon. Pick the tone for the
 * outcome; icon colours come from the Figma variants.
 */
export function StatusIcon({ icon: Icon, tone = 'brand' }: StatusIconProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'shadow-sm flex size-14 items-center justify-center rounded-xl',
        TONES[tone],
      )}
    >
      <Icon className="size-7" />
    </span>
  );
}
